/**
 * @generated SignedSource<<cdc155057bfc1056247ffc283b789f6e>>
 * @relayHash aae54959257a50f2f468862f2386ecf1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b31f49f6ec236a6845c287c4644f8705f1e68e7b74fcbaa6da51a29825bb994f

import type { ConcreteRequest } from 'relay-runtime';
export type LocalStorageQuery$variables = {
  stringKeys: ReadonlyArray<string | null>;
};
export type LocalStorageQuery$data = {
  readonly localStorage: {
    readonly stringValues: ReadonlyArray<{
      readonly key: string;
      readonly value: string | null;
    } | null>;
  } | null;
};
export type LocalStorageQuery = {
  response: LocalStorageQuery$data;
  variables: LocalStorageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "stringKeys"
  }
],
v1 = [
  {
    "concreteType": "LocalStorage",
    "kind": "LinkedField",
    "name": "localStorage",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "keys",
            "variableName": "stringKeys"
          }
        ],
        "concreteType": "LocalStorageStringPair",
        "kind": "LinkedField",
        "name": "stringValues",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "value"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LocalStorageQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LocalStorageQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "aae54959257a50f2f468862f2386ecf1",
    "id": "b31f49f6ec236a6845c287c4644f8705f1e68e7b74fcbaa6da51a29825bb994f",
    "metadata": {},
    "name": "LocalStorageQuery",
    "operationKind": "query",
    "text": "query LocalStorageQuery($stringKeys:[String]!){localStorage{stringValues(keys:$stringKeys){key,value}}}"
  }
};
})();

(node as any).hash = "c77010885edcb870219ed5e01c01d23e";

export default node;
